class GoogleMap {

	constructor (params) {
		this.o                 = params;
		this.map               = null;
		this.prevInfo          = null;
		this.marker            = null;
		this.markerUser        = null;
		this.infowindowUser    = null;
		this.autocomplete      = null;
		this.directionsService = null;
		this.directionsDisplay = null;
		this.arrayMarkers = [];
	}

	/**
	 * [initMap Inicializa el mapa]
	 * @return {[type]} [description]
	 */
	initMap() {		
		var stylez;

		if(typeof this.o != 'object')
		{
			console.error('Error al inicializar el mapa - el contructor necesita recibir un object');
			return;
		}

		if(typeof this.o.wrapper == 'undefined' || typeof this.o.lat == 'undefined' || typeof this.o.long == 'undefined')
		{
			console.error('Error al inicializar el mapa - error en parametros');
			return;
		}	

		var latLong = new google.maps.LatLng(Number(this.o.lat), Number(this.o.long));
		var options = 
		{
			zoom      : Number(this.o.zoom),
			center    : latLong,
			mapTypeId : google.maps.MapTypeId.ROADMAP,
			disableDefaultUI : true,
			mapTypeControlOptions: 
			{
				 mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'greyscale']
			   }
		}
		
		//Constructores
		this.map               = new google.maps.Map(document.getElementById(this.o.wrapper), options);			
		this.directionsService = new google.maps.DirectionsService();
		this.directionsDisplay = new google.maps.DirectionsRenderer();

		//Oculto los markers de ruta
		this.directionsDisplay.setOptions( { suppressMarkers: true } );

		//Crea el mapa en escala de grises
		if(this.o.greyscale)
		{
			stylez = 
			[
				{
				  featureType : "all",
				  elementType : "all",
				  stylers     : [{ saturation: -100 }]
				}
			];

			var mapType = new google.maps.StyledMapType(stylez, { name:"Grayscale" });
			this.map.mapTypes.set('greyscale', mapType);
			this.map.setMapTypeId('greyscale');
		}
	}

	/**
	 * [setMarker crea un marker generico con los atrubitos recibidos]
	 * @param {[type]} o [description]
	 */
	setMarker (o){
		if(typeof o != 'object')
		{
			console.error('Error al inicializar el marker');
			return;
		}

		var image   = (typeof o.icon != 'undefined') ? o.icon: '';
		var latLong = new google.maps.LatLng(Number(o.lat), Number(o.long));
		
		this.marker  = new google.maps.Marker
		({
			position  : latLong,
			draggable : false,
			animation : google.maps.Animation.DROP,
			icon      : image,
			title     : o.title,
		});	

		/**
		 * [myOptionsToolTip Tooltip de infowindow customizado]
		 * @type {[type]}
		 */

		var myOptionsToolTip = 
		{
			content: o.htmlInfo,
			disableAutoPan: false,
			maxWidth: 0,
			pixelOffset: new google.maps.Size(-260, -197),
			zIndex: null,
			boxStyle: 
			{
				opacity: 1
			},
			closeBoxMargin: "7px 7px -50px 0px",
			closeBoxURL: '/img/btn_cross.png',
			infoBoxClearance: new google.maps.Size(1, 1),
			isHidden: false,
			pane: "floatPane",
			enableEventPropagation: true
		};

		if(o.infoWindow)
		{
			google.maps.event.addListener(this.marker, 'click', () =>
			{
				 //Me acerco al marker y me centro 
				 this.map.setCenter(this.marker.getPosition());
				 
				 if(typeof o.zoom != 'undefined')
				 {
					this.map.setZoom(o.zoom);
				 }
				 else
				 this.map.setZoom(14);

				return () => 
				{
					$('.infoBox').hide().delay(150).remove();						
					var ib = new InfoBox(myOptionsToolTip);
					ib.open(this.map, this.marker);
				}

			});
		}

		if(this.map != null)
		{
			this.marker.setMap(this.map);		
			arrayMarkers.push(this.marker);
		}
	}

	/**
	 * [createNewMarker crea un marker especifico]
	 * @param  {[type]} o [description]
	 * @return {[type]}   [description]
	 */
	createNewMarker(o){
		if(typeof o != 'object')
		{
			console.error('Error al inicializar el marker');
			return;
		}

		var image   = (typeof o.icon != 'undefined') ? o.icon: '';
		var latLong = new google.maps.LatLng(Number(o.lat), Number(o.long));
		
		var newMarker  = new google.maps.Marker
		({
			position  : latLong,
			draggable : false,
			animation : google.maps.Animation.DROP,
			icon      : image,
			title     : o.title,
		});	

		/**
		 * [myOptionsToolTip Tooltip de infowindow customizado]
		 * @type {[type]}
		 */

		var myOptionsToolTip = 
		{
			content: o.htmlInfo,
			disableAutoPan: false,
			maxWidth: 0,
			pixelOffset: new google.maps.Size(-260, -197),
			zIndex: null,
			boxStyle: 
			{
				opacity: 1
			},
			closeBoxMargin: "7px 7px -50px 0px",
			closeBoxURL: '/img/btn_cross.png',
			infoBoxClearance: new google.maps.Size(1, 1),
			isHidden: false,
			pane: "floatPane",
			enableEventPropagation: true
		};
		
		if(o.infoWindow)
		{
			google.maps.event.addListener(this.newMarker, 'click', () =>
			{
				 //Me acerco al newMarker y me centro 
				 this.map.setCenter(this.newMarker.getPosition());
				 this.map.setZoom(12);

				return () => 
				{
					$('.infoBox').hide().delay(150).remove();						
					var ib = new InfoBox(myOptionsToolTip);
					ib.open(this.map, this.newMarker);
				}

			});
		}

		if(map != null)
		{
			newMarker.setMap(map);	
			this.arrayMarkers.push(newMarker);
		}
	}

	/**
	 * [setCenter centra el mapa en las coord recibidas y además crea markers]
	 * @param {[type]} lat  [description]
	 * @param {[type]} long [description]
	 */
	setCenterUser(lat, long, zipCode){
		var geocoder = new google.maps.Geocoder();
		var latLong  = null;

		if(typeof lat != 'undefined' && typeof long != 'undefined' && lat != null && long != null)
		{
			latLong  = new google.maps.LatLng(lat,long);

			/**
			 * obtengo la direccion en base a la latitud y longitud
			 * @param  {[type]} results [description]
			 * @param  {[type]} status) 				{if (status [description]
			 * @return {[type]}         [description]
			 */
			geocoder.geocode({'latLng': latLong}, function(results, status) 
			{
				if (status == google.maps.GeocoderStatus.OK) 
				{
					 if (results[0]) 
					 {
						findServiceController.setDirection(results[0].formatted_address);
						lat = results[0].geometry.location.lat();
						lng = results[0].geometry.location.lng();

						createMarkerUser(latLong);

						findServiceController.setCoords(lat, lng, results[0]);						     
					 } 
					 else 
						findServiceController.setError('No se ha podido encontrar tu ubicación');
				} 
				else 
					 findServiceController.setError('No se ha podido encontrar tu ubicación');
			});
		}
		
		//Obtengo coords por zipCode
		
		else if(zipCode != null)
		{
			geocoder.geocode( { 'address': String(zipCode)}, function(results, status) 
			{
				if (status == google.maps.GeocoderStatus.OK)  
				{
					if (results[0]) 
					{
						lat     = results[0].geometry.location.lat();
						lng     = results[0].geometry.location.lng();
						latLong = new google.maps.LatLng(lat,lng);

						createMarkerUser(latLong);
						findServiceController.setCoords(lat, lng, results[0]);

						//findServiceController.resolveDistanceBetweenPointPublic();	
					}
					else 
						findServiceController.setError('No se ha podido encontrar tu ubicación');
				} 
				else 
					 findServiceController.setError('No se ha podido encontrar tu ubicación');
			});
		}
	}

	/**
	 * [createMarkerUser description]
	 * @param  {[type]} latLong [description]
	 * @return {[type]}         [description]
	 */
	createMarkerUser(latLong) {
		if(latLong != null)
		{
			/**
			 * Centro el mapa 
			 */
			map.setCenter(latLong);

			/**
			 * Creo el marker antes evaluo si el marker ya no existia
			 * @type {google}
			 */
			
			if(markerUser == null)
			{
				markerUser  = new google.maps.Marker
				({
					position  : latLong,
					draggable : false,
					icon      : '/img/home-mark.png',
					animation : google.maps.Animation.DROP
				});	

				infowindowUser = new google.maps.InfoWindow();
				infowindowUser.setContent('<div style="width:200px; height:25px; text-align:center; padding: 5px 5px;"><strong>Tu estás aquí</strong><br>');
				//infowindowUser.open(map, markerUser);
			}
			else
			{
				/**
				 * si el marker ya fue creado vuelvo a colocarlo en la nueva posicion
				 */
				markerUser.setPosition(latLong);
			}
			
			markerUser.setMap(map);
			map.setZoom(12);

			this.arrayMarkers.push(markerUser);
		}
		else
			console.error('error latlong');			
	}

	/**
	 * [setCenter description]
	 * @param {[type]} lat  [description]
	 * @param {[type]} long [description]
	 */
	setCenter(lat , long){
		var latLong  = new google.maps.LatLng(lat,long);
			map.setCenter(latLong);
			map.setZoom(9);
	}

	/**
	 * [createAutoComplete description]
	 * @param  {[type]} input [description]
	 * @return {[type]}       [description]
	 */
	createAutoComplete(input){
		autocomplete = new google.maps.places.Autocomplete(input);
		google.maps.event.addListener(autocomplete, 'place_changed', onAutoCompleteChange);			
	}

	/**
	 * [onAutoCompleteChange description]
	 * @return {[type]} [description]
	 */
	onAutoCompleteChange(){
		var place = autocomplete.getPlace();
		
		console.info(place);

		if (!place.geometry) 
		{
		  findServiceController.setError('No se ha podido encontrar tu ubicación');
		  return;
		}
		else
		{
			lat = place.geometry.location.lat();
			lng = place.geometry.location.lng();
			
			self.setCenterUser(lat, lng, null);
		}
	}

	/**
	 * [createRoute description]
	 * @param  {[type]} start [description]
	 * @param  {[type]} end   [description]
	 * @return {[type]}       [description]
	 */
	createRoute(oStart , oEnd){
		this.directionsDisplay.setMap(map);
		
		var start  = new google.maps.LatLng(Number(oStart.lat), Number(oStart.lng));
		var end    = new google.maps.LatLng(Number(oEnd.lat), Number(oEnd.lng));
		
		var request = 
		{
			origin: start,
			destination: end,
			travelMode: google.maps.DirectionsTravelMode.DRIVING
		};
		
		this.directionsService.route(request, function(response, status) 
		{
			if (status == google.maps.DirectionsStatus.OK)
			{
				this.directionsDisplay.setDirections(response);
			}
			else
			{
				findServiceController.setErrorLocation('No se han podido encontrar caminos.');
			}
		});
	}

	/**
	 * [clearOverlays limpia todos los overlays del mapa markers, roads, etc]
	 * @return {[type]} [description]
	 */
	clearOverlays(){
		for(var i = 0; i < this.arrayMarkers.length; ++i)
		{
			this.arrayMarkers[i].setMap(null);
		}
	
		this.arrayMarkers = [];
		this.map.setZoom(11);
		this.directionsDisplay.setMap(null);
	}
}

export default GoogleMap;